import React from "react";
import { ToggleButton, ToggleButtonGroup, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CategorySelector({ value, onChange }) {
  const navigate = useNavigate();

  const handleChange = (event, newCategory) => {
    if (newCategory !== null) {
      if (newCategory === "General Enquiry") {
        navigate("/dashboard/general-enquiry");
      } else {
        if (onChange) onChange(newCategory);
      }
    }
  };

  const categories = [
    "all",
    "Land",
    "Gioo Nano plots",
    "Gio Rental Yield - Syndicate plots",
    "Gio Rental Yield",
    "flats/villas",
    "General Enquiry",
  ];

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        py: 1,
        px: { xs: 1, sm: 0 },
      }}
    >
      <ToggleButtonGroup
        value={value || "all"}
        exclusive
        onChange={handleChange}
        aria-label="category selector"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          borderRadius: { xs: "24px", sm: "9999px" },
          backgroundColor: "rgba(0,0,0,0.75)", // Darker background like image
          px: { xs: 1.2, sm: 1.5 },
          py: { xs: 1.2, sm: 0.8 },
          rowGap: { xs: 1.2, sm: 1 }, // Reduced gap
          columnGap: { xs: 1, sm: 1.2, md: 1.5 }, // Reduced gap
          border: "none",
          width: "auto",
          maxWidth: "100%",

          "& .MuiToggleButton-root": {
            border: "1px solid rgba(255,255,255,0.3) !important", // White outline
            borderRadius: "9999px !important",
            backgroundColor: "transparent",
            mx: 0,
            "&:not(:first-of-type)": {
              marginLeft: 0,
            },
          },
        }}
      >
        {categories.map((cat) => (
          <ToggleButton
            key={cat}
            value={cat}
            aria-label={cat}
            sx={{
              fontSize: {
                xs: "0.75rem",
                sm: "0.78rem",
                md: "0.9rem",
                lg: "1rem",
              },
              textTransform: "none",
              color: "white",
              px: {
                xs: "14px",
                sm: "16px",
                md: "20px",
              },
              py: { xs: "6px", sm: "6px" },
              whiteSpace: "nowrap",
              minWidth: "auto",
              minHeight: "auto",
              lineHeight: 1.5,

              "&.Mui-selected": {
                background: "linear-gradient(to right, #C7DD94, #92AF5D)",
                color: "white",
                "&:hover": {
                  background: "linear-gradient(to right, #C7DD94, #92AF5D)",
                },
              },
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.12)",
              },
            }}
          >
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}